import routes from '@/modules/users/users-routes';
// import store from '@/modules/users/users-store';

export default {
  routes,
//   store
};